// @MX:NOTE: [AUTO] china-inapi 이관 완료 — instance 에는 chinaInapi(FollowerList.vue)가 주입된다.
//   GET /cn/wechat/followers, /cn/wechat/followers/detail 는 SPEC-CHINA-ADMIN-CERT-FOLLOWER-EP-001 §5.5 동결 경로.
//   레거시 한국 inapi 경로(/wechat/follower, /wechat/follower/detail)는 더 이상 사용하지 않는다.
//   (SPEC-CHINA-ADMIN-CERT-FOLLOWER-EP-001 M2, 2026-07-24)
export default function followerApis(instance) {
  return {
    // hasCard는 호출부가 명시적으로 전달한 값을 그대로 사용한다(폴백 없음).
    // FollowerList.vue 기본값은 'ALL'(진입 시 전체 팔로워 노출).
    getFollowerList(params) {
      return instance.get('/cn/wechat/followers', {
        params
      });
    },
    getFollowerDetail(unionId) {
      return instance.get('/cn/wechat/followers/detail', {
        params: { unionId }
      });
    },
    // 공중계정(gzh) 선택 옵션 조회 — 플랫폼 운영자(xinlaian)에게만 유효, 제조사는 자기 것 1건만 반환
    getGzhOptions() {
      return instance.get('/cn/wechat/followers/gzh-options');
    },
    // 팔로워 통계 대시보드 조회 (SPEC-CHINA-ADMIN-CERT-FOLLOWER-EP-001 통계 확장) — gzhName 미지정 시 전체 집계
    // gzhName은 단일 값 또는 comma-separated 문자열(FollowerStats.vue 멀티선택, BE $in 조회 계약)을 모두 허용한다.
    getFollowerStats(gzhName) {
      return instance.get('/cn/wechat/followers/stats', {
        params: gzhName && gzhName !== 'ALL' ? { gzhName } : {}
      });
    }
  };
}
